import { Fragment } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { X } from 'lucide-react';


const AppDeleteDialog = ({
  isOpen,
  title,
  description,
  onClose,
  onConfirm,
  confirmTitle = "Reject",
  isLoading,
  hideCloseBtn = false,
}) => {
  if (!isOpen) return null;

  return (
    <Fragment>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-50"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
        <div 
          className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-auto overflow-hidden"
          style={{ boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15)' }}
          onClick={e => e.stopPropagation()}
        >
          {/* Header */}
          <div className="relative py-8 px-6">
            <h3 className="text-xl font-bold text-center">
              {title}
            </h3>
            
            {!hideCloseBtn && (
              <button
                onClick={onClose}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 rounded-full p-1 transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
            )}
          </div>

          {/* Content */}
          <div className="">
            <p className="text-center text-[16px]">
              {description}
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-center py-8 px-6 gap-3 bg-gray-50">
            {!hideCloseBtn && (
              <button
                onClick={onClose}
                disabled={isLoading}
                className="px-14 py-3 rounded-full bg-green-700 text-white font-semibold hover:bg-green-800 disabled:opacity-70 min-w-[100px] transition-colors"
              >
                Close
              </button>
            )}
            
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className={`px-14 py-3 rounded-full font-semibold min-w-[100px] flex items-center justify-center transition-colors
                ${isLoading 
                  ? 'bg-red-600 text-white' 
                  : 'bg-[#EB4E4E] text-white hover:bg-[#c62828]'}`}
            >
              {isLoading ? (
                <>
                  <CircularProgress size={20} color="inherit" className="mr-2" />
                  Processing...
                </>
              ) : (
                confirmTitle
              )}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AppDeleteDialog;